import axios from '@/libs/api.request'
import config from '@/config'

const baseUrl = config.workSheetApi + '/worksheet/api/v1/'
export const logisticsUploadImgUrlChat = baseUrl + 'upload_img_chat/'
export const logisticsUploadFileUrlChat = baseUrl + 'upload_file_chat/'

export const GetWorkSheet = (params) => {
  return axios.request({
    url: baseUrl + 'worksheet/',
    params: params,
    method: 'get'
  })
}

export const GetALLWorkSheet = (params) => {
  return axios.request({
    url: baseUrl + 'all_worksheet_list/',
    params: params,
    method: 'get'
  })
}

export const GetWorkSheetExport = (params) => {
  return axios.request({
    url: baseUrl + 'export_worksheet/',
    params: params,
    method: 'get'
  })
}

export const GetWorkSheetSystemExport = (params) => {
  return axios.request({
    url: baseUrl + 'export_worksheet_system/',
    params: params,
    method: 'get'
  })
}

export const GetWorkSheetAllExport = (params) => {
  return axios.request({
    url: baseUrl + 'export_worksheet_all/',
    params: params,
    method: 'get'
  })
}

export const GetALLUserWorkSheet = () => {
  return axios.request({
    url: baseUrl + 'all_worksheet_user/',
    method: 'get'
  })
}

export const detailWorkSheet = (id) => {
  return axios.request({
    url: baseUrl + 'worksheet/' + id + '/',
    method: 'get'
  })
}

export const ChangeWorkSheet = (data, id) => {
  let url = baseUrl + 'worksheet/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const DeleteWorkSheet = (id) => {
  return axios.request({
    url: baseUrl + 'worksheet/' + id + '/',
    method: 'delete'
  })
}

export const GetWSAllUser = (params) => {
  return axios.request({
    url: baseUrl + 'all_user/',
    params: params,
    method: 'get'
  })
}

export const GetWSAllGroup = (params) => {
  return axios.request({
    url: baseUrl + 'all_group/',
    params: params,
    method: 'get'
  })
}

export const AppointApi = (data) => {
  return axios.request({
    url: baseUrl + 'appoint/',
    data: data,
    method: 'post'
  })
}

export const ReceiveApi = (data) => {
  return axios.request({
    url: baseUrl + 'receive/',
    data: data,
    method: 'post'
  })
}

export const ServiceCommApi = (data) => {
  return axios.request({
    url: baseUrl + 'service_comm/',
    data: data,
    method: 'post'
  })
}

export const ProcessApi = (data) => {
  return axios.request({
    url: baseUrl + 'process/',
    data: data,
    method: 'post'
  })
}

export const CloseApi = (data) => {
  return axios.request({
    url: baseUrl + 'close/',
    data: data,
    method: 'post'
  })
}

export const OpenApi = (data) => {
  return axios.request({
    url: baseUrl + 'open/',
    data: data,
    method: 'post'
  })
}

export const GetOperateLogsApi = (params) => {
  return axios.request({
    url: baseUrl + 'operate_log/',
    params: params,
    method: 'get'
  })
}

export const GetCommunicateApi = (params) => {
  return axios.request({
    url: baseUrl + 'communicate/',
    params: params,
    method: 'get'
  })
}

export const GetFileListApi = (params) => {
  return axios.request({
    url: baseUrl + 'file_list/',
    params: params,
    method: 'get'
  })
}

export const editDeadlineApi = (data) => {
  return axios.request({
    url: baseUrl + 'edit_deadline/',
    data: data,
    method: 'post'
  })
}

export const editTypeApi = (data) => {
  return axios.request({
    url: baseUrl + 'edit_type/',
    data: data,
    method: 'post'
  })
}

export const editSonTypeApi = (data) => {
  return axios.request({
    url: baseUrl + 'edit_son_type/',
    data: data,
    method: 'post'
  })
}

export const editCcEmailApi = (data) => {
  return axios.request({
    url: baseUrl + 'edit_cc_email/',
    data: data,
    method: 'post'
  })
}

export const editEmailApi = (data) => {
  return axios.request({
    url: baseUrl + 'edit_email/',
    data: data,
    method: 'post'
  })
}

// 消耗品领用工单
export const getConsumablesWorksheet = (params) => {
  return axios.request({
    url: baseUrl + 'consumables_worksheet/',
    params: params,
    method: 'get'
  })
}

// 消耗品领用工单
export const deleteConsumablesWorksheet = (data) => {
  return axios.request({
    url: baseUrl + `consumables_worksheet/${data.id}/`,
    data: data,
    method: 'delete'
  })
}
